import MoveTo from 'moveto'

/**
 * Toggle accordion content just beneath the toggle button
 */
const Accordion = (function () {
  // Accordions
  let accordionToggles = document.querySelectorAll('.js-accordion-toggle')

  return {
    init: () => {
      if (accordionToggles) {
        Array.from(accordionToggles).forEach((accordionToggle) => {
          accordionToggle.addEventListener('click', (e) => {
            const { title } = e.currentTarget.dataset
            const expanded = e.currentTarget.getAttribute('aria-expanded')
            const panel = e.currentTarget.nextElementSibling

            // Toggle ARIA
            e.currentTarget.setAttribute('aria-expanded', expanded !== 'true')
            e.currentTarget.classList.toggle('accordion-element__toggle--expand')

            // Update button ARIA
            const buttonAriaLabel = expanded !== 'true' ? `Close ${title}` : `Open ${title}`

            e.currentTarget.setAttribute('aria-label', buttonAriaLabel)

            // Toggle classes
            panel.classList.toggle('accordion-element__content--open')
            panel.classList.toggle('visually-hidden')
            panel.toggleAttribute('hidden')

            if (!panel.classList.contains('visually-hidden')) {
              if (!panel.classList.contains('no-scroll')) {
                // scroll
                const moveTo = new MoveTo({
                  tolerance: 300,
                  easing: 'easeOutQuart',
                })
                moveTo.move(panel)
              }
            }
          })
        })
      }
    },
  }
})()

export default Accordion
